import { createAsyncAction } from "../utils/actionCreators";

export const types = {
  OBTER_ERRO_OS: "@@baterias/OBTER_ERRO_OS",
};

export const actions = {
  obterRoteiroInconsistencia: createAsyncAction(types.OBTER_ERRO_OS),
};
